// src/v2/pages/Reports/ReportR3.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportR3 } from '../../hooks/useReportR3';
import { ReportR3Module } from '../../components/modules/Reports/ReportR3/ReportR3Module';

const ReportR3 = ({ isHideSideMenu }) => {
  const reportHook = useReportR3();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportR3Module reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportR3;